import EditButton from 'utils/ComponentGenericEdit/EditButton';
import DataTable from 'widgets/datagrid/DataTable';

const OfferIdsTable = ({ rows = [], loading = false, onEdit }) => {
  const columns = [
    {
      field: 'offer_id',
      headerName: 'OfferID',
      flex: 1,
      minWidth: 200,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'name',
      headerName: 'Nombre',
      flex: 1,
      minWidth: 250,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'actions',
      headerName: 'Editar',
      width: 140,
      align: 'center',
      headerAlign: 'center',
      sortable: false,
      renderCell: (params) => <EditButton onClick={() => onEdit?.(params.row)} />,
    },
  ];

  return (
    <DataTable
      rows={rows}
      columns={columns}
      loading={loading}
      page={0}
      pageSize={50}
      rowCount={rows.length}
    />
  );
};

export default OfferIdsTable;
